/* eslint-disable react/destructuring-assignment,prefer-destructuring */
import React, { Component } from 'react';
import _ from 'lodash';
import { withSize } from 'react-sizeme';
import { Modal } from 'antd';
import { VOCABULARY_LIST_LIST_STATE_LOADING } from '../../store/terminus/terminusConstants';

const LIST_SWITCH = {
  [VOCABULARY_LIST_LIST_STATE_LOADING]: true,
};

export default (bottle) => {
  // eslint-disable-next-line prefer-arrow-callback,func-names
  bottle.factory(
    'TerminusContainer',
    ({
      TerminusView, terminusRowSelect, editUrl, newUrl, terminusColumns,
    }) => withSize({ refreshRate: 200, refreshMode: 'throttle' })(class TerminusContainer extends Component {
      constructor(props) {
        super(props);
        this.state = { data: false };
      }

      componentDidMount() {
        this.props.fetchTerms();
        if (this.props.listChecklistClearFlag) {
          this.props.setListStateChecks([]);
          this.props.setListClearFlag(false);
        }
      }

      get goHome() {
        return () => {
          this.props.history.push('/');
        };
      }

      get goPredefinedVocabulary() {
        this.props.setListClearFlag(true);
        return group => this.props.history.push(editUrl(group));
      }

      get goNew() {
        return () => this.props.history.push(newUrl);
      }

      static getDerivedStateFromProps(props, state) {
        const {
          termIDs,
          modelCustomVocabularyById,
        } = props;

        const data = termIDs.reduce((records, id) => {
          if (modelCustomVocabularyById[id]) {
            return [...records, modelCustomVocabularyById[id]];
          }
          return records;
        }, []);
        return { ...state, data };
      }

      get selectRow() {
        return (data) => {
          if (this.props.listEditState) {
            this.toggleInRow(data);
          } else {
            terminusRowSelect(data, this.props, this);
          }
        };
      }

      get rowSelection() {
        return {
          selectedRowKeys: this.props.listChecklist,
          onChange: this.props.setListStateChecks,
        };
      }

      get checkLength() {
        return _.get(this.props, 'listChecklist.length', 0);
      }

      get deleteSelectedLists() {
        return () => {
          if (!this.checkLength) {
            Modal.confirm({
              title: 'Delete Vocabulary Lists',
              content: 'You must check at least one list to delete',
              okText: 'OK',
            });
          } else {
            Modal.confirm({
              title: 'Delete Vocabulary Lists',
              content: `Delete ${this.checkLength} Lists?`,
              okText: 'Delete Lists',
              cancelText: 'Cancel',
              onOk: (done) => {
                this.props.deleteCheckedLists();
                this.forceUpdate();
                done();
              },
            });
          }
        };
      }

      get isLoading() {
        return _.get(LIST_SWITCH, this.props.listState, false);
      }

      get columns() {
        return terminusColumns({
          size: this.props.size.width < 768 ? 'small' : 'large',
          goPredefinedVocabulary: this.goPredefinedVocabulary,
          downloadVocabCSV: this.props.downloadVocabCSV,
        });
      }

      render() {
        return (
          <TerminusView
            {...this.state}
            {...this.props}
            title="Vocabulary Lists"
            goHome={this.goHome}
            goNew={this.goNew}
            onSelect={this.selectRow}
            isLoading={this.isLoading}
            canDelete={!!this.checkLength}
            rowSelection={this.rowSelection}
            deleteSelected={this.deleteSelectedLists}
            columns={this.columns}
            checkLength={this.checkLength}
          />
        );
      }
    }),
  );
};

